DigiTickets.GiftVoucherDeliveryType = Object.freeze({
    EMAIL: 'Email',
    IN_PERSON: 'In Person',
    POST: 'Post'
});
